module.exports = __webpack_public_path__ + "static/media/Amber Bulloch Headshot.2f08b69c.png";